import { FC } from 'react';

import { ReportProps } from '../index';
import s from './Footer.module.scss';

export const Footer: FC<ReportProps> = ({ workerFIO, t }) => (
  <div className={s.container} id="report-footer">
    <div className={s['sign-block']}>
      <span className={s.header}>{t('reports.workShift.print.finisher')}</span>
      <div className={s['sign']}>
        <span className={s['fio']}>{workerFIO}</span>
        <span>/</span>
      </div>
    </div>
    <div className={s['sign-block']}>
      <span className={s.header}>{t('reports.workShift.print.getter')}</span>
      <div className={s['sign']}>
        <span className={s['fio']} />
        <span>/</span>
      </div>
    </div>
  </div>
);
